import {Component, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Component({
    selector: 'dropdown-actions',
    templateUrl: './dropdown-actions.component.html',
    styleUrls: ['./dropdown-actions.component.scss'],
})
export class DropdownActionsComponent {

    public actionsOpened = false;

    @Input()
    public width: string;

    @Input()
    public positionDropdown: PositionDropdown = 'BOTTOMLEFT';
    public fromPositionDropdown = fromPositionDropdown;

    @Input()
    labelKey: string;

    @Output()
    toggled: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private elementRef: ElementRef) {
    }

    public toggleActions(): void {
        this.actionsOpened = !this.actionsOpened;
        this.toggled.emit(this.actionsOpened);
    }

    @HostListener('document:click', ['$event'])
    public onClickOut(event): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.actionsOpened = false;
            this.toggled.emit(this.actionsOpened);
        }
    }
}

export type PositionDropdown =
    'TOPRIGHT'
    | 'TOPLEFT'
    | 'TOPCENTER'
    | 'BOTTOMRIGHT'
    | 'BOTTOMLEFT'
    | 'BOTTOMCENTER'
    | 'LEFT';

export function fromPositionDropdown(positionDropdown: PositionDropdown): string {
    switch (positionDropdown) {
        case 'TOPRIGHT':
            return '_topRight';
        case 'TOPLEFT':
            return '_topLeft';
        case 'TOPCENTER':
            return '_topCenter';
        case 'BOTTOMRIGHT':
            return '_bottomRight';
        case 'BOTTOMLEFT':
            return '_bottomLeft';
        case 'BOTTOMCENTER':
            return '_bottomCenter';
        case 'LEFT':
            return '_left';
    }
}
